module.exports = __webpack_public_path__ + "img/kl-marathon-2-2018.bd5c0fd4.png";